export default {
notification: {
  read: "Đã đọc",
  unread: "Chưa đọc",
  hide: "Ẩn",
  showAll: "Hiển thị tất cả",
  loading: "Đang tải...",
  noMore: "Không còn dữ liệu",
  platform: "Nền tảng",
  personal: "Cá nhân"
}
};
